module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-120x120-precomposed-bb9a4ddb89cb258d164e6d3336db00e5.png";